<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-data-iterator :items="items" :loading="loading">
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.id"
                cols="12"
                sm="12"
                md="6"
                lg="4"
              >
                <induction-card :item="item"
                  ><template slot="title">{{
                    item.name
                  }}</template></induction-card
                >
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import InductionCard from "@/components/induction/InductionCard";
import TestService from "@/services/TestService.js";
export default {
  components: {
    InductionCard
  },
  data() {
    return {
      loading: false,
      items: []
    };
  },
  created() {
    this.getInductions();
  },
  methods: {
    getInductions() {
      this.loading = true;
      TestService.getTests()
        .then(response => {
          this.items = response;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
